import { DeepMap, FieldError } from 'react-hook-form'
import { IAuthRepsAction } from 'redux/reducers/auth-reps'
import { FormErrorAlertContainer, FormErrorAlertItem } from 'components/ReactHookForm/errors'
import { useTranslation } from 'react-i18next'

export interface AuthRepFormErrorAlertProps {
  errors: DeepMap<IAuthRepsAction, FieldError>
  isLimitedInformation: boolean
  isAllCheckboxValuesFalse: boolean
  isNewYorkResident: boolean
  isSpecificDisclosurePeriod: boolean
  validAuthStartDate: boolean
  validAuthEndDate: boolean
  isSubmitted: boolean
  setFocusOnAlert: () => void
}

export const AuthRepFormErrorAlert: React.FC<AuthRepFormErrorAlertProps> = ({
  errors,
  isLimitedInformation,
  isAllCheckboxValuesFalse,
  isNewYorkResident,
  isSpecificDisclosurePeriod,
  validAuthStartDate,
  validAuthEndDate,
  isSubmitted,
  setFocusOnAlert
}) => {
  const { t } = useTranslation('authRep')
  return (
    <FormErrorAlertContainer>
      <>
        {errors.repFullName?.message &&
          <FormErrorAlertItem
            href='#repFullName'
            anchorText={t('incompleteInformation.links.repFullName')}
            errorDescription={errors.repFullName.type === 'pattern' ? t('invalidRegex.genericSpecialCharactersError') : t('incompleteInformation.repFullName')}
          />
        }
        {errors.organizationName?.message &&
          <FormErrorAlertItem
            href='#organizationName'
            anchorText={t('incompleteInformation.links.organizationName')}
            errorDescription={t('invalidRegex.genericSpecialCharactersError')}
          />
        }
        {errors.repAddress?.address1?.message &&
          <FormErrorAlertItem
            href='#repAddress.address1'
            anchorText={t('incompleteInformation.links.address1')}
            errorDescription={errors.repAddress?.address1.type === 'pattern' ? t('invalidRegex.genericSpecialCharactersError') : t('incompleteInformation.address1')}
          />
        }
        {errors.repAddress?.city?.message &&
          <FormErrorAlertItem
            href='#repAddress.city'
            anchorText={t('incompleteInformation.links.city')}
            errorDescription={errors.repAddress?.city?.type === 'pattern' ? t('invalidRegex.genericSpecialCharactersError') : t('incompleteInformation.city')}
          />
        }
        {errors.repAddress?.zip?.message &&
          <FormErrorAlertItem
            href='#repAddress.zip'
            anchorText={t('incompleteInformation.links.zip')}
            errorDescription={t('incompleteInformation.zip')}
          />
        }
        {errors.repAddress?.state?.message &&
          <FormErrorAlertItem
            href='#repAddress.state'
            anchorText={t('incompleteInformation.links.state')}
            errorDescription={t('incompleteInformation.state')}
          />
        }
        {errors.repRelationshipToBene?.message &&
          <FormErrorAlertItem
            href='#repRelationshipToBene'
            anchorText={t('incompleteInformation.links.repRelationshipToBene')}
            errorDescription={t('incompleteInformation.repRelationshipToBene')}
          />
        }
        {errors.disclosureLimitations?.limitedInformation?.message &&
          <FormErrorAlertItem
            href='#disclosureLimitations.limitedInformation'
            anchorText={t('incompleteInformation.links.limitedInformation')}
            errorDescription={t('fieldLabels.disclosurePeriod.heading')}
          />
        }
        {isLimitedInformation && isAllCheckboxValuesFalse &&
          <FormErrorAlertItem
            data-testid='limited-info-error-message'
            onClick={setFocusOnAlert}
            href='#limitedInfoAlert'
            anchorText={t('incompleteInformation.discloseLimitedInformation')}
            errorDescription={t('incompleteInformation.discloseLimitedCheckbox')}
          />
        }
        {errors.disclosureLimitations?.otherSpecificInformation?.message &&
          <FormErrorAlertItem
            href='#disclosureLimitations.otherSpecificInformation'
            anchorText={t('incompleteInformation.links.otherSpecificInformation')}
            errorDescription={
              errors.disclosureLimitations?.otherSpecificInformation?.type === 'pattern'
                ? t('invalidRegex.genericSpecialCharactersError')
                : t('incompleteInformation.otherSpecificInformation')
            }
          />
        }
        {isNewYorkResident && errors.nyDrugInformation?.message &&
          <FormErrorAlertItem
            href='#nyDrugInformation'
            anchorText={t('incompleteInformation.links.nyDrugInformation')}
            errorDescription={t('incompleteInformation.nyDrugInformation')}
          />
        }
        {errors.disclosurePeriod?.message &&
          <FormErrorAlertItem
            href='#disclosurePeriod'
            anchorText={t('incompleteInformation.links.disclosurePeriod')}
            errorDescription={t('incompleteInformation.disclosurePeriod')}
          />
        }
        {(isSpecificDisclosurePeriod && !validAuthStartDate) && isSubmitted &&
          <FormErrorAlertItem
            href='#authStartDate.month'
            anchorText={t('incompleteInformation.links.authStartDate')}
            errorDescription={t('incompleteInformation.authStartDate')}
          />
        }
        {(isSpecificDisclosurePeriod && !validAuthEndDate) && isSubmitted &&
          <FormErrorAlertItem
            href='#authEndDate.month'
            anchorText={t('incompleteInformation.links.authEndDate')}
            errorDescription={t('incompleteInformation.authEndDate')}
          />
        }
        {errors.disclosureReason?.message &&
          <FormErrorAlertItem
            href='#disclosureReason'
            anchorText={t('incompleteInformation.links.disclosureReason')}
            errorDescription={errors.disclosureReason.type === 'pattern'
              ? t('invalidRegex.genericSpecialCharactersError')
              : t('incompleteInformation.disclosureReason')
            }
          />
        }
        {errors.acknowledgeCheckbox?.message &&
          <FormErrorAlertItem
            href='#acknowledgeCheckbox'
            anchorText={t('fieldLabels.acknowledgeCheckbox.name')}
            errorDescription={t('incompleteInformation.acknowledgeCheckbox')}
          />
        }
      </>
  </FormErrorAlertContainer>
  )
}
